import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { isString } from 'lodash';
import CloseButton from 'components/common/buttons/closeButton';
import { serializeClasses } from 'utilities/css';
import {
  StyledBody,
  StyledContent,
  StyledCloseButton,
  StyledHeader,
  StyledIcon,
  StyledTypeContainer,
} from './styled';
import { alertClasses, alertTypes } from '../constants';

const Icon = ({ display: IconComponent }) => {
  if (!IconComponent) {
    return null;
  }
  return (
    <StyledIcon className="icon">
      <IconComponent />
    </StyledIcon>
  );
};

Icon.propTypes = {
  display: PropTypes.func
};

Icon.defaultProps = {
  display: null
};

const renderDismissButton = (onDismiss, setVisible) => {
  const hasDismissFunction = onDismiss instanceof Function;
  if (!hasDismissFunction) {
    return null;
  }
  const handleClick = () => {
    setVisible(false);
    onDismiss();
  };
  return (
    <StyledCloseButton>
      <CloseButton onClick={handleClick} />
    </StyledCloseButton>
  );
};

const renderBody = (id, content) => {
  const arrContent = Array.isArray(content) ? content : [content];
  return arrContent.map((body, index) => {
    const key = `alert-body-${id}-${index}`;
    const text = isString(body) ? body : JSON.stringify(body);
    return <StyledBody key={key}>{text}</StyledBody>;
  });
};

export const BaseAlert = ({
  id,
  header,
  content,
  onDismiss,
  icon,
  className,
  isVisible
}) => {
  const [visible, setVisible] = useState(isVisible);
  if (!visible) {
    return null;
  }
  const button = renderDismissButton(onDismiss, setVisible);
  const body = renderBody(id, content);

  return (
    <StyledTypeContainer className={serializeClasses([className])}>
      {button}
      <Icon display={icon} />
      <StyledContent className="alert-content">
        {header && <StyledHeader className="alert-header">{header}</StyledHeader>}
        {body}
      </StyledContent>
    </StyledTypeContainer>
  );
};

BaseAlert.propTypes = {
  id: PropTypes.string,
  isVisible: PropTypes.bool,
  header: PropTypes.string,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  onDismiss: PropTypes.func,
  icon: PropTypes.func,
  className: PropTypes.string,
};

BaseAlert.defaultProps = {
  id: (Math.random()).toString(),
  isVisible: true,
  header: undefined,
  content: undefined,
  onDismiss: undefined,
  icon: undefined,
  className: alertClasses[alertTypes.DEFAULT]
};

export default BaseAlert;
